query StampCommonData {
  companyCorporatePeriods(
    filter: { isEntryAllowed: { equalTo: true } }
    orderBy: [IS_ENTRY_ALLOWED_DESC, START_DATE_ASC]
  ) {
    nodes {
      isEntryAllowed
      id
      _periodYear
      startDate
      endDate
    }
  }
  batchTransactions(
    orderBy: [DESCRIPTION_ASC, REFERENCE_NUMBER_ASC, PRIMARY_KEY_ASC]
    filter: {
      _accountingStampDate: { isNull: true }
      isDraft: { equalTo: true }
    }
  ) {
    nodes {
      id
      _rowTimestamp
      referenceNumber
      description
      currency {
        isoCode
      }
      companyCorporatePeriod {
        _periodYear
        startDate
        endDate
      }
      corporatePeriodId
    }
  }
}
